const links = [
  {
    id: 1,
    name: "Classes",
    href: "/classes",
  },
  {
    id: 2,
    name: "Lessons",
    href: "/lessons",
  },
  {
    id: 3,
    name: 'Audio',
    href: '/audio'
  },
  {
    id: 4,
    name: "Services",
    href: "/services",
  },
  {
    id: 5,
    name: "Volunteer",
    href: "/volunteer",
  },
  {
    id: 6,
    name: "About",
    href: "/about",
  },
  {
    id: 7,
    name: "Donate",
    href: "/donate",
  },
  ];

  export default links;